import React, { useEffect } from 'react'

import ThirdPartyScripts from './ThirdPartyScripts'

import useSessionStorage from '../hooks/useSessionStorage'
import { useInstrumentation } from '../utils/instrumentation'

const getPageId = (location) => (location ? location.pathname : '#')

const Layout = ({ children, location }) => {
  const [previousPage, setPreviousPage] = useSessionStorage('previousPage', getPageId(location))
  const { trackEvent } = useInstrumentation()

  useEffect(() => {
    if (location) {
      const _hsq = window._hsq || []

      const pageId = getPageId(location)
      let activity = 'pageLoad'
      let payload = { to: pageId }

      if (previousPage !== pageId) {
        payload.from = previousPage
        activity = 'pageChange'
      }

      const urlWithParams = location.pathname + location.search + location.hash
      payload.source = urlWithParams

      _hsq.push(['setPath', urlWithParams])
      _hsq.push(['trackPageView'])

      trackEvent({
        pageId,
        activity,
        payload,
      })

      setPreviousPage(pageId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  return (
    <React.Fragment>
      <ThirdPartyScripts />
      {children}
    </React.Fragment>
  )
}

export default Layout
